/**
 * @name providers
 * @description Core providers in ngx-responsive
 *
 * @license MIT
 */
export * from './responsive-config/index';
export * from './responsive-state/index';
export * from './responsive-base/index';
